/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/user';
import { USER } from '@/store/types';
import { AdminItem, AdminProps } from '@/api/types/user';

export interface StoreUserAdminState {
  admins: AdminItem[];
  id: string;
  admin: AdminProps;
}

export default {
  namespaced: true,
  state: {
    admins: [],
    id: '',
    admin: null,
  },
  getters: {},
  actions: {
    [USER.GET_ADMINS]({ commit }) {
      return new Promise((resolve, reject) => {
        api.getAdmins().then((res) => {
          commit(USER.GET_ADMINS, res.data);
          resolve();
        }).catch(reject);
      });
    },
    [USER.GET_ADMIN]({ commit }, { id }) {
      return new Promise((resolve, reject) => {
        api.getAdmin(id).then((res) => {
          commit(USER.GET_ADMIN, res.data);
          resolve();
        }).catch(reject);
      });
    },
    [USER.SET_ADMIN](_, { id, body }) {
      return new Promise((resolve, reject) => {
        api.setAdmin(id, body).then(() => {
          resolve();
        }).catch(reject);
      });
    },
    [USER.DEL_ADMIN](_, { id }) {
      return new Promise((resolve, reject) => {
        api.delAdmin(id).then(() => {
          resolve();
        }).catch(reject);
      });
    },
    [USER.GET_ID](_, { name }) {
      return new Promise((resolve, reject) => {
        api.getPeek({ name }).then((res) => {
          resolve(res.data);
        }).catch(reject);
      });
    },
    [USER.GET_NAME](_, { id }) {
      return new Promise((resolve, reject) => {
        api.getPeek({ id }).then((res) => {
          resolve(res.data);
        }).catch(reject);
      });
    },
  },
  mutations: {
    [USER.GET_ADMINS](state, admins: AdminItem[]) {
      state.admins = admins;
    },
    [USER.GET_ADMIN](state, admin: AdminProps) {
      state.admin = admin;
    },
  },
};
